import React from "react";

/**
 * Honeypot field — visually hidden from humans + screen readers, harvested by
 * naive bots that auto-fill anything that looks like a website/url field.
 *
 * IMPORTANT: the field name and label MUST NOT match any common autofill
 * heuristic. Password managers (1Password, Bitwarden, Chrome / Safari autofill)
 * and Cloudflare's form helpers will eagerly fill anything labeled "company
 * website", "email", "phone", etc. — even if the field is positioned
 * off-screen and aria-hidden. A real user with autofill enabled would then
 * trip the honeypot and the form would silently fake-succeed.
 *
 * `_hp_check` is intentionally meaningless. No label. No `name` attribute that
 * matches an autocomplete category.
 *
 * Backend silently 200s if this field is non-empty.
 */
export default function Honeypot({ register }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <input
        type="text"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        {...register("_hp_check")}
      />
    </div>
  );
}
